<template>
    <div>
        <!-- Form fields for the model would go here -->
        <div class="row">
            <p class="card-text">
                Vous allez changer le statut du modèle vers <strong>{{ modelStatusInfo[item.status]?.label }}</strong>
            </p>

            <div class="mb-3 col-md-6" v-if="formData.status=='delivered'">
                <label for="delivery_date_model" class="form-label">Date de livraison</label>
                <input type="date" class="form-control" id="delivery_datemodel"
                    v-model="formData.delivery_date">
            </div>

        </div>

        <div class="row mt-2">
            <div class="col text-end">
                <button class="btn btn-success" @click="save"><i
                        class="bi bi-check-circle me-1"></i>Valider</button>
                <button type="button" class="btn btn-secondary mx-2"
                    @click="$emit('cancel')"><i
                        class="bi bi-x-circle me-1"></i>Annuler</button>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import ModelStatus from '@/enums/ModelStatus';
export default {
    name: 'ModelChangeStatusForm',
    mixins: [formMixin],
    emits:['cancel'],
    props: {
        client_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            defaultData: {
                nom: ''
            },
            url: '/styles',
            datesCols: ['delivery_date'],
            ...ModelStatus,
        }
    },
    methods: {
        beforeSave() {
            this.formData.client_id = this.client_id;
        }
    }

}
</script>